import { Injectable } from '@angular/core';
import { Action, AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument, DocumentSnapshot, Query, QueryDocumentSnapshot, QueryFn } from '@angular/fire/firestore';
// import { NotificationService } from './notification.service';
import { catchError, map } from 'rxjs/operators';

import { of, Observable, throwError } from 'rxjs';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { NotificationService } from './notification.service';
import { AuthenticationService } from './auth.service';
import { LogService } from './log.service';
// import { User } from '../model/user';
// import { LogLevel, LogService } from './log.service';


/*
  .-firestore mappában tárolni .rules-ban a rule-okat
   - szerepkörök kezelése, lekérdezése
   . jogosultságok tárolása úgy a dokumentumon, hogy ne változtathassa meg (esetleg külön tárolni, és bekérdezni szerver oldalon...)
*/
@Injectable({
  providedIn: 'root'
})
export class FirestoreService {

  constructor(private fs: AngularFirestore, private ns: NotificationService, private auth: AuthenticationService, private logger: LogService) {}

  create<T>(path: string, data: T) {
    Object.keys(data).forEach(key => {
      if (data[key] === undefined)  {data[key] = null; }
    });

    return this.fs.collection<T>(path).add(data)
    .then(doc => doc)
    .catch(error => {
      this.logger.createError(null, error, `dokumentum létrehozás hiba. path: ${path}, data: ${JSON.stringify(data)}`);
      console.error(error);

      // this.logService.createLog(LogLevel.error, 'documentum létrehozás sikertelen', {path: path, data, error});

      throw(error);
    });
  }

  set<T>(path: string, data: T, id?: string, writeIdToData?: boolean, merge = false) {
    Object.keys(data).forEach(key => {
      if (data[key] === undefined)  {data[key] = null; }
    });
    const docRef = id ?  this.fs.collection<T>(path).doc(id) : this.fs.collection<T>(path).doc();
    if (writeIdToData) {
      data['id'] = docRef.ref.id;
    }
    return docRef.set(data, {merge})
      .then(() => {
        return docRef;
      })
      .catch((error) => {
        console.error(error);

        // this.logService.createLog(LogLevel.error, 'documentum létrehozás sikertelen (set)', {path: path, data, id, error});
        this.logger.createError(null, error, `dokumentum létrehozás (set) hiba. path: ${path}, data: ${JSON.stringify(data)}`);
        this.ns.showError('Hiba: létrehozás sikertelen', 'Bezár', 0);
        throw(error);
      })
  }

  update<T>(path: string, data: T, throwError = false) {
    // tslint:disable-next-line: no-string-literal
    const id = data['id'];
    if (id) {

      Object.keys(data).forEach(key => {
        if (data[key] === undefined)  {data[key] = null; }
      });

      const doc = this.getDocRef<T>(path, id);
      return doc.update(data).catch(error => {
        console.error(error);
        this.logger.createError(null, error, `dokumentum update hiba. path: ${path}, data: ${JSON.stringify(data)}, id: ${id}`);
        throw error;

      });
      // return doc.get().pipe(
      //   switchMap(d => {
      //     if (d.exists) {
      //       return d.ref.update(data);
      //     } else {
      //       throw new Error(`Nem létező id update-nél. Path: ${path}, id: ${id}`);
      //     }
      //   }),
      //   catchError(error => {
      //     console.error(error);
      //     if (throwError) {
      //       throw new Error(error);
      //     } else {
      //       this.ns.openSnackBar('Hiba: módosítás sikertelen', 'Bezár', 0);
      //     }
      //     return of(null);
      //   })
      // );
    } else {
      console.error('Hiányzó Id mező update-nél', path, data);
      // this.logService.createLog(LogLevel.error, 'documentum módosítás sikertelen (nincs id)', {path: path, data});
      this.ns.showError('Hiba: módosítás sikertelen', 'Bezár', 0);
      this.logger.createError(null, null, `Hiányzó Id mező update-nél, ${path}, ${JSON.stringify(data) }`);
      throw new Error(`Hiányzó Id mező update-nél, ${path}`);

    }
  }

  delete<T>(path: string, id: string) {
    if (path && id) {
      return this.fs.collection(path).doc(id).delete()
      .then(() => true)
      .catch(error => {
        console.error(error);
        // this.logService.createLog(LogLevel.error, 'documentum törlés sikertelen', {path: path, id, error});
        this.ns.showError('Hiba: törlés sikertelen', 'Bezár', 0);
        return false;
      });
    } else {
      console.error('Hiányzó path, vagy id törlésnél', path, id);
      this.logger.createError(null, null, `Hiányzó Id mező törlésnél, ${path}, id: ${id}`);
      // this.logService.createLog(LogLevel.error, 'documentum törlés sikertelen (nincs id)', {path: path});
      this.ns.showError('Hiba: törlés sikertelen', 'Bezár', 0);
      return Promise.resolve(false);
    }
  }

  // getElementBefore<T>(element: QueryDocumentSnapshot<T>, sort: {active:string, direction: SortDirection}) {
  //   console.log('path', element.ref.path);
  //   console.log('parentPath', element.ref.parent.path);
  //   let direction: 'asc' | 'desc';
  //   if (sort.direction === 'asc') {
  //       direction = 'desc'
  //   } else {
  //       direction = 'asc';
  //   }
  //   return this.fs.collection<T>(element.ref.parent.path, ref => ref
  //     .orderBy(sort.active, direction)
  //     .limit(1)
  //     .startAfter(element)
  //   ).snapshotChanges().pipe(
  //     map(resp => {
  //       console.log('resp', resp);
  //       return resp[0]?.payload.doc;
  //     })
  //   );
  // }

  getRandomId() {
    // adatot nem írunk bele, csak kell egy id
    const id = this.fs.collection('hosts').doc().ref.id;
    // console.log(id);
    return id;
  }

  getPaginatedData<T>(path: string, limit: number, action: string, orderby: {fieldPath: string, direction: firebase.firestore.OrderByDirection},
    whereFilters: {fieldPath: string, opStr: firebase.firestore.WhereFilterOp, value: any}[],
    pFirst?: QueryDocumentSnapshot<T>, pLast?: QueryDocumentSnapshot<T>) {
    // majd filtert beépíteni !!
    let ob = orderby;
    if (!ob) {
      ob.direction = 'asc';
      ob.fieldPath = 'id';
    }

    return this.fs.collection<T>(path, ref => {
      let q: Query = ref;
      q = q.limit(limit +1);
      if (action === 'prew') {
        q = q.orderBy(ob.fieldPath, ob.direction === 'asc' ? 'desc' : 'asc');
        q = q.startAfter(pFirst);
      } else {
        q = q.orderBy(ob.fieldPath, ob.direction);
        if (pLast) {
          q = q.startAfter(pLast)
        }
      }

      whereFilters?.forEach(whereFilter => {
        q = q.where(whereFilter.fieldPath, whereFilter.opStr, whereFilter.value);
      })

      return q;
    }).snapshotChanges().pipe(
      map(val => {
        let prewEnabled = false;
        let nextEnabled = false;
        if (val.length > 0) {
          if (action === 'prew') {
            // ha visszafelé lépünk, akkor alapból a next engedélyezve van
            nextEnabled = true;
            prewEnabled = val.length > limit;
            if (prewEnabled) {
              val.pop();
            }
            // sorrend az eredetibe
            val.reverse();
          } else {
            if (action === 'next') {
              // ha előre lépünk, akkor a vissza engedélyezve van
              prewEnabled = true;
            }
            nextEnabled = val.length > limit;
            //mivel eggyel többet kértünk le kell venni egyet
            if (nextEnabled) {
              val.pop();
            }
          }

          // ha a paraméterben kapott last még létezik, akkor kattinthat vissza
          // prewEnabled = pLast?.exists;

          let last = val[val.length - 1].payload.doc;
          let first = val[0].payload.doc;
          return {
            first,
            last,
            prewEnabled,
            nextEnabled,
            data: val.map(r => {
              let res = (this.convertFirestoreDatePropsToDate(r.payload.doc.data()) as T);
              // let res2 = res);
              return {
                ...res,
                id: r.payload.doc.id
              }
            })
          }
        } else {
          return {first: null, last: null, data: null, prewEnabled: false, nextEnabled: false};
        }
      }),
      catchError(error => {
        // this.logService.createLog(LogLevel.error, 'documentum oldal lekérdezés sikertelen', {path, error});
        console.error(error);
        throw error;
      })
    )
  }

  getCollectionIds(path: string, queryFn?: QueryFn): Observable<string[]> {
    let q = queryFn ? this.fs.collection(path, queryFn) : this.fs.collection(path);
    return q.get().pipe(
      map(list => {
        if (!list.empty) {
          return list.docs.map(doc => {
            return doc.id;
          });
        } else {
          return [];
        }
      }),
      catchError(error => {
        // this.logService.createLog(LogLevel.error, 'getCollectionIds error', {path: path, error});
        throw error;
      })
    );
  }

  getCollectionLength(path: string, queryFn?: QueryFn) {
    let q = queryFn ? this.fs.collection(path, queryFn) : this.fs.collection(path);

    return q.snapshotChanges().pipe(
      map(sn => sn.length)
    );
  }

  deleteCollectionDocs(portfolioId: string, docPath: string, docId: string, collectionName: string) {
    // const commentsPath = `portfolios/${portfolioId}/meetings/${meetingId}/comments`;
    const path = `portfolios/${portfolioId}/${docPath}/${docId}/${collectionName}`;
    return this.getCollectionIds(path).pipe(
      map(ids => {
        return ids.map(id => {
          this.delete(path, id);
        });
      }),
      catchError(error => {
        // this.logService.createLog(LogLevel.error, 'deleteCollectionDocs hiba', {portfolioId, path: path, error});
        throw error;
      })
    );
  }

  getList<T>(path: string, queryFn?: QueryFn): Observable<(T & {id: string})[]> {

    let q: Observable<(T & {id: string})[]>;
    if (queryFn) {
      q = this.fs.collection<T>(path, queryFn).valueChanges({ idField: 'id' });
    } else {
      q = this.fs.collection<T>(path).valueChanges({ idField: 'id' });
    }

    return q.pipe(
      map(docVal => {
        // a lista elemein megyünk végig
        Object.keys(docVal).forEach(key => {
          docVal[key] = this.convertFirestoreDatePropsToDate(docVal[key]);
        });

        // instanceof csak class-ra!
        // if (docVal instanceof Task) {
        //   console.log(docVal);
        // }

        // if (path.includes('tasks')) {
        //   console.log(docVal);
        // }
        return docVal;
      }),
      // kiejelentkezéskor le kell iratkozni
      // takeUntil(this.auth.user$.pipe(filter(u => !u))),
      catchError(error => {
        console.error('Lista lekérdezés sikertelen', path, error);
        // this.logService.createLog(LogLevel.error, 'lista lekérdezés sikertelen', {path: path, error});
        return of([]);
      })
    );
  }

  getDocValue<T>(path: string, id: string): Observable<T | null> {
    return this.getDocRef<T>(path, id).valueChanges({idField: id}).pipe(
      map(docVal => {
        // return docVal;
        return this.convertFirestoreDatePropsToDate(docVal)
      }),
      // takeUntil(this.auth.user$.pipe(filter(u => !u))),
      catchError(error => {
        console.error('Dokumentum value lekérdezés sikertelen', path, id, error);
        this.logger.createError(null, error, `Dokumentum value lekérdezés sikertelen', ${path}, id: ${id}`);
        throwError(new Error(error));
        return of(null);
      })
    );
  }

  getDocOnce<T>(path: string, id: string): Observable<T | null> {
    return this.getDocRef<T>(path, id).get().pipe(
      map(doc => {
        if (doc.exists) {
          return this.convertFirestoreDatePropsToDate(doc.data());
        } else {
          return undefined;
        }
      }),
      catchError(error => {
        console.error('Dokumentum lekérdezés sikertelen', path, id, error);
        this.logger.createError(null, error, `Dokumentum lekérdezés sikertelen', ${path}, ${id}, ${error}`);
        throwError(new Error(error));
        return of(error);
      })
    );
  }

  getDocChanges<T>(path: string, id: string) : Observable<{data: T, action: Action<DocumentSnapshot<T>>}> {
    return this.getDocRef<T>(path, id).snapshotChanges().pipe(
      map(action => {
        // console.log(action.payload.data());
        // console.log(this.convertFirestoreDatePropsToDate(action.payload.data()));
        if (action.payload.exists) {
          return {
            data: this.convertFirestoreDatePropsToDate(action.payload.data()),
            action
          }
        } else {
          return {
            data: null,
            action
          }
        }

      }),
      // takeUntil(this.auth.user$.pipe(filter(u => !u))),
      catchError(error => {
        console.error('Dokumentum lekérdezés sikertelen', path, id, error);
        // this.logService.createLog(LogLevel.error, 'getDocChanges lekérdezés sikertelen', {path: path, id, error});
        return of(null);
      })
    );
  }

  getDocRef<T>(path: string, id: string): AngularFirestoreDocument<T> {
    return this.fs.collection<T>(path).doc(id);
  }

  // majd role figyelés is kell
  // https://fireship.io/lessons/firestore-joins-similar-to-sql/
  getAssignedUsers(userIds: string[]) {
    const users$ = userIds.map(userId => {
      // return this.getDocOnce<User>('users', userId);
      return this.auth.currentUser();
    });

    // return combineLatest(users$);
    return users$;
  }

  addToArray<T>(path: string, docId: string, arrayField: string, arrayValue) {
    const data: Partial<T> = {};
    const docRef = this.fs.collection(path).doc(docId);
    data[arrayField] = firebase.firestore.FieldValue.arrayUnion(...[arrayValue]);
    docRef.update(data).then(() => {
      return docRef;
    }).catch(error => {
      console.error('addToArray error ', path, docId, arrayField, arrayValue, error);
      // this.logService.createLog(LogLevel.error, 'addToArray hiba', {path: path, id: docId, arrayField, arrayValue, error});
    })
  }

  public convertFirestoreDatePropsToDate(data: {}) {
    Object.keys(data)
      .filter(propKey => (data[propKey] instanceof firebase.firestore.Timestamp))
      .forEach(propKey => data[propKey] = data[propKey].toDate());
    return data;
  }

  getServerTimeStamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  }
}
